const exportOptions = [
  { format: 'csv', label: 'Export as CSV' },
  { format: 'excel', label: 'Export as Excel' },
];

export default exportOptions;
